// extracted by mini-css-extract-plugin
export default {"container":"styles_container__P7rx2","createReply":"styles_createReply__GrqCw","button":"styles_button__IVbAJ"};